import { render, staticRenderFns } from "./CreateEditDatasources.vue?vue&type=template&id=d2ae0070&scoped=true&"
import script from "./CreateEditDatasources.vue?vue&type=script&lang=js&"
export * from "./CreateEditDatasources.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditDatasources.vue?vue&type=style&index=0&id=d2ae0070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae0070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2ae0070')) {
      api.createRecord('d2ae0070', component.options)
    } else {
      api.reload('d2ae0070', component.options)
    }
    module.hot.accept("./CreateEditDatasources.vue?vue&type=template&id=d2ae0070&scoped=true&", function () {
      api.rerender('d2ae0070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateEditDatasources.vue"
export default component.exports